import * as React from 'react';

const SvgX = props => (
  <svg
    height={27.62793}
    id="svg5"
    viewBox="0 0 23.527344 27.62793"
    width={23.527344}
    {...props}
  >
    <defs id="defs9" />
    <text
      fontFamily="ProximaNova-Regular, 'Proxima Nova'"
      fontSize="38px"
      id="X"
      letterSpacing="0.01em"
      x={11.126281}
      y={-7.3720698}
    >
      <tspan
        id="tspan2"
        x={-1.2617188}
        y={27.62793}
      >
        X
      </tspan>
    </text>
  </svg>
);

export default SvgX;

